// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import jQuery from "jquery";

// Exponer jQuery globalmente
window.jQuery = jQuery;
window.$ = jQuery;

// Initialize Bootstrap tooltips on page load and Turbo navigation
document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });
});

document.addEventListener("click", event => {
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest("[data-cx-dismiss-offcanvas]");
  if (!link) return;

  const offcanvas = link.closest(".offcanvas");
  if (!offcanvas || typeof bootstrap === "undefined") return;

  bootstrap.Offcanvas.getOrCreateInstance(offcanvas).hide();
});
